const config = {
  defaultTooltipClassName: "Tooltip",
  defaultTooltipId: "tooltip",
  defaultTooltipPlacement: "top"
};

export default config;
